import { request } from '@umijs/max';

export async function queryCategoryList(
  params?: any,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/category', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function addCategory(
  body: API.CategoryInfoVO,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/category', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

export async function updateCategory(
  id: number,
  body: API.CategoryInfoVO,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/category/${id}`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

export async function removeCategory(
  params: { id: number },
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/category/${params.id}`, {
    method: 'DELETE',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
